import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { apiService } from '../services/api';

const usePackageStore = create(devtools((set, get) => ({
	packages: [],
	loading: false,
	error: null,
	wasLoaded: false,

	fetchPackages: async (excludeQuiz = true) => {
		set({ loading: true, error: null });
		try {
			const packages = await apiService.getPackages(excludeQuiz);
			// console.log('Ответ от getPackages:', response);
			set({ packages, loading: false, wasLoaded: true });
		} catch (err) {
			set({ error: err.message || 'Ошибка при загрузке пакетов', loading: false });
		}
	}
}), { name: 'PackageStore' }));

export default usePackageStore;
